import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const Collection = styled.div`
  min-width: 256px;
  height: 80px;
  display: inline-flex;
  font-family: ${tokens.font.family.ifood.body};
  align-items: center;
  color: ${tokens.colors.white};
  border-radius: ${tokens.radii.m};
  padding: 0 30px;
  box-sizing: border-box;
  margin-right: ${tokens.space.regular};
  margin-bottom: ${tokens.space.regular};

  @media (max-width: ${tokens.breakpoints.s}) {
    display: flex;
  }
`;

export const Icon = styled.img`
  width: 36px;
  height: 36px;
  margin-right: ${tokens.space.regular};
  border: ${tokens.space.smallest} solid ${tokens.colors.white};
  border-radius: ${tokens.radii.l};
  background-color: ${tokens.colors.white};
`;

export const Title = styled.span`
  font-size: ${tokens.fontSizes.xs};
`;

export const Name = styled.span`
  font-weight: bold;
  font-size: ${tokens.fontSizes.m};
`;

export const Link = styled.a`
  text-decoration: none;
`;
